import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// --- Default (fallback) config ---
const DEFAULT_CONFIG = {
/*   apiKey: "AIzaSyBbuPLhAuDL0dap27P_ariiVk9wN45f9NA",
  authDomain: "cfc-clone.firebaseapp.com",
  databaseURL: "https://cfc-clone-default-rtdb.firebaseio.com",
  projectId: "cfc-clone",
  storageBucket: "cfc-clone.appspot.com",
  messagingSenderId: "797541597324",
  appId: "1:797541597324:web:1da24246d809068643bba9",
  measurementId: "G-J3F0ER8V13", */


  apiKey: "AIzaSyAmZtJ-TtxBRYbWdQDXHwxqNe971pRqxUw",
  authDomain: "kfg-2026.firebaseapp.com",
  databaseURL: "https://kfg-2026-default-rtdb.firebaseio.com",
  projectId: "kfg-2026",
  storageBucket: "kfg-2026.firebasestorage.app",
  messagingSenderId: "83791460020",
  appId: "1:83791460020:web:610d4ebf4f07f4f7bc89e1",
  measurementId: "G-EP5S4TJQY2"

};





const RUNTIME_CONFIG_KEY = "runtimeFirebaseConfigUrl";
const RUNTIME_CONFIG_RAW_KEY = "runtimeFirebaseConfigRaw";
const REQUIRED_KEYS = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "messagingSenderId",
  "appId",
];

// Synchronous fetch helper so init happens before first use.
function fetchConfigSync(url) {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, false); // synchronous
    xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.send(null);
    if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText) {
      return JSON.parse(xhr.responseText);
    }
  } catch (err) {
    console.warn("Runtime Firebase config fetch failed:", err);
  }
  return null;
}

function isValidConfig(cfg) {
  return (
    cfg &&
    typeof cfg === "object" &&
    REQUIRED_KEYS.every((key) => typeof cfg[key] === "string" && cfg[key].length > 0)
  );
}

function readRuntimeConfigUrl() {
  if (typeof window === "undefined") return "";
  try {
    // Allow hard override via global for secret page/scripts
    if (window.__FIREBASE_CONFIG_URL__) return String(window.__FIREBASE_CONFIG_URL__);
    const stored = window.localStorage.getItem(RUNTIME_CONFIG_KEY);
    return stored || "";
  } catch (err) {
    return "";
  }
}

function readRuntimeConfigRaw() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(RUNTIME_CONFIG_RAW_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (isValidConfig(parsed)) return parsed;
  } catch (err) {
    console.warn("Failed to parse runtime raw config:", err);
  }
  return null;
}

function loadActiveConfig() {
  // 1) Runtime raw JSON stored locally (e.g., imported file)
  const rawCfg = readRuntimeConfigRaw();
  if (isValidConfig(rawCfg)) return { config: rawCfg, source: "runtime-raw" };

  // 2) Runtime URL from localStorage/global
  const runtimeUrl = readRuntimeConfigUrl();
  if (runtimeUrl) {
    const cfg = fetchConfigSync(runtimeUrl);
    if (isValidConfig(cfg)) return { config: cfg, source: "runtime" };
  }

  // 3) Try hosted file at /firebase-config.json (can be swapped without rebuild)
  const hostedCfg = fetchConfigSync("/firebase-config.json");
  if (isValidConfig(hostedCfg)) return { config: hostedCfg, source: "hosted" };

  // 4) Fallback to default
  return { config: DEFAULT_CONFIG, source: "default" };
}

const { config: activeConfig, source: activeSource } = loadActiveConfig();

if (activeSource !== "default") {
  console.info(`Firebase config loaded from ${activeSource}`);
}

const app = getApps().length ? getApps()[0] : initializeApp(activeConfig);

export const db = getFirestore(app);

let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { analytics };
export const auth = getAuth(app);

// Allow a secret/internal page to update runtime config URL then reload.
export function setRuntimeFirebaseConfigUrl(url) {
  if (typeof window === "undefined") return;
  try {
    // Clear raw if setting a URL
    window.localStorage.removeItem(RUNTIME_CONFIG_RAW_KEY);
    if (url) {
      window.localStorage.setItem(RUNTIME_CONFIG_KEY, url);
    } else {
      window.localStorage.removeItem(RUNTIME_CONFIG_KEY);
    }
    window.location.reload();
  } catch (err) {
    console.warn("Failed to persist runtime Firebase URL:", err);
  }
}

// Allows importing a JSON config (e.g., via file input) without hosting a URL.
export function setRuntimeFirebaseConfigObject(configObject) {
  if (typeof window === "undefined") return;
  try {
    if (isValidConfig(configObject)) {
      window.localStorage.setItem(RUNTIME_CONFIG_RAW_KEY, JSON.stringify(configObject));
      window.localStorage.removeItem(RUNTIME_CONFIG_KEY); // clear URL override
      window.location.reload();
    } else {
      console.warn("Invalid Firebase config object");
    }
  } catch (err) {
    console.warn("Failed to persist runtime Firebase config:", err);
  }
}
